import { render, staticRenderFns } from "./event-table.vue?vue&type=template&id=225e8452&scoped=true"
import script from "./event-table.ts?vue&type=script&lang=ts&external"
export * from "./event-table.ts?vue&type=script&lang=ts&external"
import style0 from "./event-table.less?vue&type=style&index=0&id=225e8452&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e8452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('225e8452')) {
      api.createRecord('225e8452', component.options)
    } else {
      api.reload('225e8452', component.options)
    }
    module.hot.accept("./event-table.vue?vue&type=template&id=225e8452&scoped=true", function () {
      api.rerender('225e8452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/event-table/event-table.vue"
export default component.exports